import { useEffect, useState } from "react";
import posthogClient from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { getPublicEnv } from "../helpers";

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  const [posthogReady, setPosthogReady] = useState(false);

  useEffect(() => {
    const environment = getPublicEnv("REMIX_APP_ENVIRONMENT");
    const isDevelopment = environment === "development";
    const posthogEnabledInDev = getPublicEnv("POSTHOG_ENABLED") === "true";
    const shouldEnable = !isDevelopment || posthogEnabledInDev;

    const key = getPublicEnv("POSTHOG_KEY");
    const host = getPublicEnv("POSTHOG_HOST");

    if (!shouldEnable || !key || !host) return;

    posthogClient.init(key, {
      api_host: host,
      defaults: "2025-11-30",
      persistence: "sessionStorage",
      autocapture: false,
      capture_pageview: false,
      capture_pageleave: false,
    });
    setPosthogReady(true);
  }, []);

  if (!posthogReady) return <>{children}</>;

  return <PHProvider client={posthogClient}>{children}</PHProvider>;
}
